<div>
  <div class="image-uploader">
    <input
      type="file"
      title="{{'Upload' | translate}}"
      id="docInput"
      (change)="handleInputChangeDoc($event)">
      @if (!readOnly) {
        <label for="docInput" class="file-input-label">
          <span>{{'main.upload' | translate}}</span> <mat-icon>file_download</mat-icon>
        </label>
      }

      @if (files && files.length) {
        <div class="message-box">
          {{'main.newFile' | translate}}
        </div>
      }

      @for (file of files; track file; let i = $index) {
        <div>
          <div class="file-data">
            <mat-checkbox (change)="showFiles($event, file.id)"   [labelPosition]="'before'"  style="margin: 0 10px" [(ngModel)]="publicInfo[i]">Public</mat-checkbox>
            @switch (file.type) {
              @case ('doc') {
                <img src="assets/images/icons/doc.svg" style="width: 35px">
              }
              @case ('docx') {
                <img src="assets/images/icons/docx.svg" style="width: 35px">
              }
              @case ('jpg') {
                <img src="assets/images/icons/img.svg" style="width: 35px">
              }
              @case ('jpeg') {
                <img src="assets/images/icons/img.svg" style="width: 35px">
              }
              @case ('png') {
                <img src="assets/images/icons/img.svg" style="width: 35px">
              }
              @case ('gif') {
                <img src="assets/images/icons/img.svg" style="width: 35px">
              }
              @case ('svg') {
                <img src="assets/images/icons/img.svg" style="width: 35px">
              }
              @case ('pdf') {
                <img src="assets/images/icons/pdf.svg" style="width: 35px">
              }
              @case ('txt') {
                <img src="assets/images/icons/txt.svg" style="width: 35px">
              }
              @case ('xls') {
                <img src="assets/images/icons/xls.svg" style="width: 35px">
              }
              @default {
                <img src="assets/images/icons/file.svg" style="width: 35px">
              }
            }
            <span class="file-name">{{file.name}}</span>
            <mat-icon class="remove-icon" (click)="removeFile(file)">delete_outline</mat-icon>
          </div>
        </div>
      }


      @if (uploadedFiles && uploadedFiles.length) {
        <div class="message-box">
          {{'main.uplodedFile' | translate}}
        </div>
      }

      @for (file of uploadedFiles; track file) {
        <div >
          <div class="file-data">
            @if (!readOnly) {
              <mat-checkbox style="margin: 0 10px"  [labelPosition]="'before'"
              [(ngModel)]="file.publicAccess" (change)="changeState($event, file.id)">Public</mat-checkbox>
            }
            @switch (file.type) {
              @case ('doc') {
                <img src="assets/images/icons/doc.svg" style="width: 35px">
              }
              @case ('docx') {
                <img src="assets/images/icons/docx.svg" style="width: 35px">
              }
              @case ('jpg') {
                <img src="assets/images/icons/img.svg" style="width: 35px">
              }
              @case ('jpeg') {
                <img src="assets/images/icons/img.svg" style="width: 35px">
              }
              @case ('png') {
                <img src="assets/images/icons/img.svg" style="width: 35px">
              }
              @case ('gif') {
                <img src="assets/images/icons/img.svg" style="width: 35px">
              }
              @case ('svg') {
                <img src="assets/images/icons/img.svg" style="width: 35px">
              }
              @case ('pdf') {
                <img src="assets/images/icons/pdf.svg" style="width: 35px">
              }
              @case ('txt') {
                <img src="assets/images/icons/txt.svg" style="width: 35px">
              }
              @case ('xls') {
                <img src="assets/images/icons/xls.svg" style="width: 35px">
              }
              @default {
                <img src="assets/images/icons/file.svg" style="width: 35px">
              }
            }
            <span class="file-name">{{file.name}}</span>
            @if (!readOnly) {
              <mat-icon class="remove-icon" (click)="removeFileFromUpload(file)">delete_outline</mat-icon>
            }
            <a [href]="getFile(file.url)" target="_blank" rel="noopener noreferrer" ><mat-icon class="remove-icon">cloud_download</mat-icon></a>
          </div>
        </div>
      }
    </div>
  </div>

